// Module
var code = "<div ng-if=\"hasAccess\" ng-transclude></div>";
// Exports
module.exports = code;